import { DEFAULT_TIME_FORMAT, type TimeFormat, timeParts } from '@/lib/time';

export function formatUpcomingMeetingDateTime(
  isoString: string,
  format: TimeFormat = DEFAULT_TIME_FORMAT
): string {
  const date = new Date(isoString);
  return date.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    ...timeParts(format),
  });
}
